const ENDPOINTS = {
  veiculos: "/api/frota/veiculos",
  motoristas: "/api/frota/motoristas",
  vinculos: "/api/frota/vinculo-motorista-veiculo",
};

async function requestJson(url, options = {}) {
  const res = await fetch(url, options);
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const msg =
      (data && data.error) || `Erro na requisição (${res.status})`;
    throw new Error(msg);
  }
  return data;
}

/** Lista veículos ativos no Supabase (tabela veiculos). */
export async function fetchVeiculos({ ativo = true } = {}) {
  const q = ativo !== undefined ? `?ativo=${ativo}` : "";
  const data = await requestJson(`${ENDPOINTS.veiculos}${q}`);
  return Array.isArray(data) ? data : [];
}

/** Lista motoristas ativos no Supabase (tabela motoristas). */
export async function fetchMotoristas({ ativo = true } = {}) {
  const q = ativo !== undefined ? `?ativo=${ativo}` : "";
  const data = await requestJson(`${ENDPOINTS.motoristas}${q}`);
  return Array.isArray(data) ? data : [];
}

/** Lista vínculos motorista–veículo com joins aninhados. */
export async function fetchVinculosMotoristaVeiculo() {
  const data = await requestJson(ENDPOINTS.vinculos);
  return Array.isArray(data) ? data : [];
}

/** Carrega frota completa para atendimento (veículos, motoristas e vínculos). */
export async function fetchFrotaAtendimento({ apenasAtivos = true } = {}) {
  const filtro = apenasAtivos ? { ativo: true } : {};
  const [veiculos, motoristas, vinculos] = await Promise.all([
    fetchVeiculos(filtro),
    fetchMotoristas(filtro),
    fetchVinculosMotoristaVeiculo(),
  ]);
  return { veiculos, motoristas, vinculos };
}

/** Resolve motorista vinculado a um veículo (id, nome, cpf). */
export function resolveMotoristaDoVeiculo(
  veiculoId,
  { vinculos = [], motoristas = [] } = {},
) {
  if (!veiculoId) return null;

  const vinc = vinculos.find((v) => v.veiculo_id === veiculoId);
  if (!vinc) return null;

  if (vinc.motoristas && typeof vinc.motoristas === "object") {
    return {
      id: vinc.motorista_id || vinc.motoristas.id || "",
      nome: vinc.motoristas.nome || "",
      cpf: vinc.motoristas.cpf || "",
    };
  }

  const m = motoristas.find((x) => x.id === vinc.motorista_id);
  if (m) {
    return { id: m.id, nome: m.nome || "", cpf: m.cpf || "" };
  }

  return {
    id: vinc.motorista_id || "",
    nome: "Motorista vinculado",
    cpf: "",
  };
}

export function getVeiculoPorId(veiculos, veiculoId) {
  if (!veiculoId || !Array.isArray(veiculos)) return null;
  return veiculos.find((v) => v.id === veiculoId) || null;
}
